/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAiAgentReportHandler extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAiAgentReportHandler");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAiAgentReportHandler.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAiAgentReportHandler>): BackgroundJobPayloadForAiAgentReportHandler {
        let obj = Object.assign(new BackgroundJobPayloadForAiAgentReportHandler(), model);
        BackgroundJobPayloadForAiAgentReportHandler.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAiAgentReportHandler>): BackgroundJobPayloadForAiAgentReportHandler {
        if (!model) return null;
        return BackgroundJobPayloadForAiAgentReportHandler.newInstance(<BackgroundJobPayloadForAiAgentReportHandler> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAiAgentReportHandler) {
        if (!obj) return;

        models.BackgroundJobPayloadForAiAgentReportHandler.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAiAgentReportHandler): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAiAgentReportHandler.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the report being generated
     */
    report_id: string;

    /**
     * ID of the report run
     */
    report_run_id: string;

}
